import { Field, FieldWrapper } from '@progress/kendo-react-form';
import React from 'react';
import FormContainer from './FormContainer';
import CusAppDtlsPreviewTitle from './CusAppDtlsPreviewTitle';
import { CusFormLabelRtl, FormSubTitle } from '../validation/Form-Components';
import appDetailsData from '../data/applicantdetailsdata.json';
import helper from '../factory/Helper.js';
import genders from '../data/gender.json';
import races from '../data/racecode.json';
import nationalies from '../data/nationality.json';
import residencyCodes from '../data/residentialcode.json';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import countries from '../data/countries.json';
import countryCodes from '../data/countrycode.json';
import occupations from '../data/industrylist.json';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import positions from '../data/position.json'
import myInfoApiCountries from '../data/myInfoApiCountryList.json';
 
const ApplicantDtlsPreview = (props) => {
    const history = useHistory();
    const {seq, applicantDtls, hasMyInfo, isFirstUser,isSoleProps,holders} = props;
    let descActOccListStr = '',persWealthCouStr=''; 
 
    
    const handleOnEdit = () => {
        if(isSoleProps){
            history.push(config.route.ApplicantDetails, { from: config.route.Preview });
        }
        else {
            if(applicantDtls.Authorised === undefined || applicantDtls.Authorised === 'true') {
                history.push(config.route.NSApplicantDetails, { from: config.route.Preview });
            }
            else {
                history.push(config.route.ShareholdersDetails, { from: config.route.Preview });
            }
            
        }
    }

    const getIDNum = () => {
        
        if(isFirstUser) {
            return applicantDtls.IDNum;
        }

        return helper.mask(applicantDtls.IDNum,4);
    }

    const getPersWealthCouStr = () => {
   
       try{
        if(applicantDtls.PersWealthSG === 'Y' ||applicantDtls.PersWealthSG === null) {
            persWealthCouStr = 'Yes';
            return;
        }

        let labelArray = [];
        if(applicantDtls.PersWealthCou !== undefined && applicantDtls.PersWealthCou !== null) {
         
            getCheckedArray(applicantDtls.PersWealthCou).map( value => {
                if(value.toUpperCase() === 'OTH') {
                    labelArray.push('Others('+helper.getLabelInArray(applicantDtls.PersWealthCou.PersWealthOTH,countries)+')');
                }
                else {
                    labelArray.push(helper.getLabelInArray(value, countries))
                }
            })
            persWealthCouStr = labelArray.join(', ');
     
            return persWealthCouStr;
        }
       }
       catch(ex) {
       }
    }

    const getCheckedArray = (resChkObj) => {
        let array = [];
        for (const [key, value] of Object.entries(resChkObj)) {
            if(value === 'true') {
                array.push(key);
            }
        }
        return array;
    }

    const getOccupationStr = () => {
        try{
            let labelArray = [];
            if(!Array.isArray(applicantDtls.DescAccOccList.DescActOcc)) {
                descActOccListStr = helper.getObjInArray(applicantDtls.DescAccOccList.DescActOcc,occupations).label;
            }
            else {
         
                for(let i in applicantDtls.DescAccOccList.DescActOcc) {
                    labelArray.push(helper.getObjInArray(applicantDtls.DescAccOccList.DescActOcc[i],occupations).label);
                }
    
                descActOccListStr = labelArray.join('; ');
            }
            return descActOccListStr;
        }
        catch(ex){

        }
    }

    const titleString = () => {
        if(isSoleProps) {
            return 'Authorised Person Details';
        }
        else if(applicantDtls.Authorised === undefined || applicantDtls.Authorised === 'true'){
            return 'Authorised Person '+seq+' Details';
        }
        else if(applicantDtls.Authorised==='false') {
            return 'Shareholder '+applicantDtls.SHSeq+' Details';
        }
    }

    return(
        <FormContainer>
        <fieldset>
        <Field component={CusAppDtlsPreviewTitle} id={'ApplicantDetails'} name={titleString()} 
            showEdit={isFirstUser} onEdit={handleOnEdit} doneMyInfo={hasMyInfo} isSoleProps={isSoleProps} />    
        <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
        {/* <div style={{paddingTop: "10px"}}> <hr className="yellowPanelLine" /> </div> */}
        {hasMyInfo? <div>
        <FieldWrapper>

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblName'} leftLabelName={appDetailsData.label.n}
            id={'Name'} name={applicantDtls.Name !== null? applicantDtls.Name:''} />
        </FieldWrapper>
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblHanPinName'} leftLabelName={appDetailsData.label.hanPinName} 
            id={'hanPinName'} name={applicantDtls.HanyuName !==null? applicantDtls.HanyuName:''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblAliasName'} leftLabelName={appDetailsData.label.aliName} 
            id={'aliasName'} name={applicantDtls.AliasName !== null? applicantDtls.AliasName:''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblHanyuAliasName'} leftLabelName={appDetailsData.label.hanPinAliName} 
            id={'hanyuAliasName'} name={applicantDtls.HanyuAliasName !== null? applicantDtls.HanyuAliasName:''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblmarName'} leftLabelName={appDetailsData.label.marName} 
            id={'marriedName'} name={applicantDtls.MarriedName !== null?applicantDtls.MarriedName:''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblIC'} leftLabelName={appDetailsData.label.ic} 
            id={'idNum'} name={applicantDtls.IDNum !== null? getIDNum():''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblDOB'} leftLabelName={appDetailsData.label.dob} 
            id={'dob'} name={applicantDtls.DOB !==null? applicantDtls.DOB:''} />
    
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblGender'} leftLabelName={appDetailsData.label.gender} 
            id={'gender'} name={applicantDtls.Gender !== null? helper.getLabelInArray(applicantDtls.Gender,genders):''} />
    
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblRace'} leftLabelName={appDetailsData.label.race} 
            id={'race'} name={applicantDtls.Race!==null? helper.getLabelInArray(applicantDtls.Race,races):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblNationality'} leftLabelName={appDetailsData.label.nationality} 
            id={'nationality'} name={applicantDtls.Nationality !== null? helper.getLabelInArray(applicantDtls.Nationality,nationalies):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblCountryOfBirth'} leftLabelName={appDetailsData.label.countryOfBirth} 
            id={'countryOfBirth'} name={applicantDtls.CnOfBirth !==null? helper.getLabelInArray(applicantDtls.CnOfBirth,myInfoApiCountries):''} />
    
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblResiStatus'} leftLabelName={appDetailsData.label.resiStatus} 
            id={'resiStatus'} name={applicantDtls.ResStatus !==null? helper.getLabelInArray(applicantDtls.ResStatus,residencyCodes):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblDesignation'} leftLabelName={appDetailsData.label.designation} 
            id={'designation'} name={helper.getDesignationbyIDNum(applicantDtls.IDNum,holders) !== null? helper.getLabelInArray(helper.getDesignationbyIDNum(applicantDtls.IDNum,holders),positions):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblTitle'} leftLabelName={appDetailsData.titleDDL.lblname} 
            id={'title'} name={applicantDtls.Title !==null? helper.getLabelInArray(applicantDtls.Title,titles):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblCnOfDom'} leftLabelName={appDetailsData.label.countryOfDom} 
            id={'CnOfDom'} name={applicantDtls.CnOfDom !==null? helper.getLabelInArray(applicantDtls.CouOfDom,countries):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblCnOfDom'} leftLabelName={appDetailsData.marStatusDDL.lblname} 
            id={'CnOfDom'} name={applicantDtls.MarStatus !==null? helper.getLabelInArray(applicantDtls.MarStatus,marStatusArray):''} />
 
        <Field component={FormSubTitle} id={'st1ApplicantDetails'} name={appDetailsData.formSubTitle.ST1}   />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblCnOfDomMobileNoCode'} leftLabelName={appDetailsData.label.cc} 
            id={'MobileNoCode'} name={applicantDtls.MobileNoCode !==null? helper.getLabelInArray(applicantDtls.MobileNoCode,countryCodes):''} />

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblMobileNo'} leftLabelName={appDetailsData.label.mno} 
            id={'MobileNo'} name={applicantDtls.MobileNo !== null? applicantDtls.MobileNo:''} />
            
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblEmailAdd'} leftLabelName={appDetailsData.label.em} 
            id={'EmailAdd'} name={applicantDtls.EmailAdd !== null?applicantDtls.EmailAdd:''} />

        <Field component={FormSubTitle} id={'st2ApplicantDetails'}  name={appDetailsData.formSubTitle.ST2} />
        {applicantDtls.ResAddType !== config.addTypeLocal?
        <div>
        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblAddline1'} leftLabelName={appDetailsData.label.addLine1}
            id={'addline1'} name={applicantDtls.ResAddLine1 !==null? applicantDtls.ResAddLine1:''}/>

        <Field component={CusFormLabelRtl} 
            leftLabelId={'lblAddline1'} leftLabelName={appDetailsData.label.addLine2}
            id={'addline1'} name={applicantDtls.ResAddLine2 !==null? applicantDtls.ResAddLine2:''}/>
        </div>
    : <div>
    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblBlk'} leftLabelName={appDetailsData.label.blk} 
        id={'blk'} name={applicantDtls.ResBlkNo !== null?applicantDtls.ResBlkNo:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblStreet'} leftLabelName={appDetailsData.label.street} 
        id={'st'} name={applicantDtls.ResStreet !== null? applicantDtls.ResStreet:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblLvl'} leftLabelName={appDetailsData.label.level} 
        id={'lvl'} name={applicantDtls.ResFlrNum !== null?applicantDtls.ResFlrNum:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblUno'} leftLabelName={appDetailsData.label.unitNo} 
        id={'uno'} name={applicantDtls.ResUnitNo !== null? applicantDtls.ResUnitNo:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblbuilding'} leftLabelName={appDetailsData.label.building} 
        id={'bld'} name={applicantDtls.ResBldName !== null? applicantDtls.ResBldName:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblPostalCode'} leftLabelName={appDetailsData.label.postalCode} 
        id={'ptc'} name={applicantDtls.ResPostalCode !== null? applicantDtls.ResPostalCode:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblcountry'} leftLabelName={appDetailsData.label.country} 
        id={'ctry'} name={applicantDtls.ResCountry !==null? helper.getLabelInArray(applicantDtls.ResCountry,myInfoApiCountries):''}  />
    </div>
    }
    {(applicantDtls.Authorised === undefined || applicantDtls.Authorised === 'true')&&
    <div>
    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailAddrSameAsRes'} leftLabelName={appDetailsData.label.sameAsRegBizAdd} 
        id={'MailAddrSameAsRes'} name={applicantDtls.MailAddrSameAsRes && applicantDtls.MailAddrSameAsRes !==null? applicantDtls.MailAddrSameAsRes === 'N'? 'No':'Yes':'Yes'}  />

    {applicantDtls.MailAddrSameAsRes !== 'N'? null : 
    <div>

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMBlk'} leftLabelName={appDetailsData.label.blk} 
        id={'MailBlkNo'} name={applicantDtls.MailBlkNo !==null? applicantDtls.MailBlkNo:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailStreet'} leftLabelName={appDetailsData.label.street} 
        id={'MailStreet'} name={applicantDtls.MailStreet !==null? applicantDtls.MailStreet:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailFlrNum'} leftLabelName={appDetailsData.label.level} 
        id={'MailFlrNum'} name={applicantDtls.MailFlrNum !==null? applicantDtls.MailFlrNum:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailUnitNo'} leftLabelName={appDetailsData.label.unitNo} 
        id={'MailUnitNo'} name={applicantDtls.MailUnitNo !==null? applicantDtls.MailUnitNo:''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailBldName'} leftLabelName={appDetailsData.label.building} 
        id={'MailBldName'} name={applicantDtls.MailBldName !==null? applicantDtls.MailBldName:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailPostalCode'} leftLabelName={appDetailsData.label.postalCode} 
        id={'MailPostalCode'} name={applicantDtls.MailPostalCode !== null? applicantDtls.MailPostalCode:''}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMailCountry'} leftLabelName={appDetailsData.label.country} 
        id={'MailCountry'} name={applicantDtls.MailCountry !==null? helper.getLabelInArray(applicantDtls.MailCountry,countries):''}  />
    </div>
    }   
    </div>
    }
    <Field component={FormSubTitle} id={'st3ApplicantDetails'}  name={appDetailsData.formSubTitle.ST4} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblDescActOccList'} leftLabelName={appDetailsData.formSubTitle.ST6} 
        id={'DescActOccList'} name={getOccupationStr()}  />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblPersWealthSG'} leftLabelName={appDetailsData.label.persWealthSG} 
        id={'PersWealthSG'} name={applicantDtls.PersWealthSG === 'N'? 'No':'Yes'}  />

    {applicantDtls.PersWealthSG==='N'?
    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblPersWealthCou'} leftLabelName={appDetailsData.label.ctrySourceWealth} 
        id={'PersWealthCou'} name={getPersWealthCouStr()}  />:null}
    </div>:
    <div>
    <FieldWrapper>
    <Field component={CusFormLabelRtl} 
            leftLabelId={'lblName'} leftLabelName={appDetailsData.label.n}
            id={'Name'} name={applicantDtls.Name !== null? applicantDtls.Name:''} />
    </FieldWrapper>
    <Field component={FormSubTitle} id={'st1ApplicantDetails'} name={appDetailsData.formSubTitle.ST1}   />
    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblCnOfDomMobileNoCode'} leftLabelName={appDetailsData.label.cc} 
        id={'MobileNoCode'} name={applicantDtls.MobileNoCode !==null? helper.getLabelInArray(applicantDtls.MobileNoCode,countryCodes):''} />

    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblMobileNo'} leftLabelName={appDetailsData.label.mno} 
        id={'MobileNo'} name={applicantDtls.MobileNo !== null? applicantDtls.MobileNo:''} />
    
    <Field component={CusFormLabelRtl} 
        leftLabelId={'lblEmailAdd'} leftLabelName={appDetailsData.label.em} 
        id={'EmailAdd'} name={applicantDtls.EmailAdd !== null?applicantDtls.EmailAdd:''} />

       </div>}

        </fieldset>
    </FormContainer>  
    )
}

export default ApplicantDtlsPreview